module.exports = __webpack_public_path__ + "static/media/welcome_popup.e707b181.png";